// libs
import React, { memo, useState } from 'react';

// anlaytics
import { trackCollapsibleSectionClicked } from 'shared/layouts/DetailsPage/analytics';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// styles
import {
  Container,
  HeaderIconContainer,
  Title,
  Header,
  Subtitle,
  HeaderContainer,
  EmptyIconPlaceHolder,
} from './styles';

// defs
interface ICollapsibleHeader {
  isExpanded: boolean;
  title: string;
  subtitle: string;
  iconName: string;
}

function CollapsibleHeader({ isExpanded, title, subtitle, iconName }: ICollapsibleHeader) {
  const [headerClickedOnced, setHeaderClickedOnced] = useState(false);
  const showProductDescriptionIcons = useRemoteConfig('showProductDescriptionIcons');


  const BoxIcon = useStoreIcon(IconName.BOX);
  const AlertInfoIcon = useStoreIcon(IconName.ALERT_INFO);
  const AccountMoreIcon = useStoreIcon(IconName.ACCOUNT);
  const CircleExchangeIcon = useStoreIcon(IconName.CIRCLE_EXCHANGE);

  const onHeaderClicked = (expanded: boolean) => {
    if (!headerClickedOnced && expanded === false) {
      trackCollapsibleSectionClicked(title);
      setHeaderClickedOnced(true);
    }
  };

  const getHeaderIcon = (icon: string) => {
    switch (icon) {
      case 'icon-box':
        return <BoxIcon />;
      case 'icon-information':
        return <AlertInfoIcon />;
      case 'icon-bn-account':
        return <AccountMoreIcon />;
      case 'icon-circle-exchange':
        return <CircleExchangeIcon />;
      default:
        return <EmptyIconPlaceHolder />;
    }
  };

  return (
    <Container data-test="container-test" onClick={() => onHeaderClicked(isExpanded)}>
      <HeaderContainer isExpanded={isExpanded} data-test="hc-test">
        {showProductDescriptionIcons && (
          <HeaderIconContainer>{getHeaderIcon(iconName)}</HeaderIconContainer>
        )}
        <Header isExpanded={isExpanded}>
          <Title data-at="product-info">{title}</Title>
          {!isExpanded && <Subtitle>{subtitle}</Subtitle>}
        </Header>
      </HeaderContainer>
    </Container>
  );
}

export default memo(CollapsibleHeader);
